import React from "react";
import './Salaryprint.css'
import logo from '../../assets/logo.png'
import { Col, Image, Row, Descriptions, Table } from "antd";
import moment from "moment";

const SalaryPrint = React.forwardRef((props, ref) => {
    const columns=[
        {
            title:'Description',
            dataIndex:'description'
        },
        {
            title:'Quantity',
            dataIndex:'quantity'
        },
        {
            title:'Amount',
            dataIndex:'amount'
        }
    ]

    const data=[
        {
            key:'1',
            description: 'Basic Salary',
            quantity:'',
            amount:`${props.basicsalary}`
        },
        {
          key:'2',
          description:"Total Working Days",
          quantity:'',
          amount:`${props.workingDays}`  
        },
        {
            key:'3',
            description: 'Overtime',
            quantity:`${props.overTimeHours} X ${props.overTimeHoursCost}`,
            amount:`${props.overTimeHoursCost* props.overTimeHours}`
        },
        {
            key:'4',
            description: 'Bonus Amount',
            quantity:'',
            amount:`${props.getFixed}`
        },
        {
            key:'5',
            description: 'Advance Amount',
            quantity:'',
            amount:`${props.advanceAmount}`
        },
        {
            key:'6',
            description:'Total Deductions',
            amount:`${props.deductions}`
        },
        {
            key:'7',
            description:<b>'Total Amount'</b> ,
            quantity:'',
            amount:<b>{props.calculateSalaryAmount}</b>
        }


    ]
    let today = moment().format('DD/MM/YYYY')
    return (
        <div ref={ref}>
            <h2 className="heading">Payslip</h2>
            <Row>
                <Col span={12}>
                    <Descriptions labelStyle={{fontWeight:'bolder'}} style={{paddingTop:'20px'}}>
                        <Descriptions.Item label="EMP Id" labelStyle={{fontWeight:'bold',padding:'0px',margin:'0px'}} span={4}>{props.empId}</Descriptions.Item>
                        <Descriptions.Item label="Full Name" labelStyle={{fontWeight:'bold',padding:'0px',margin:'0px'}} span={4}>{props.employeeName}</Descriptions.Item>
                        <Descriptions.Item label="Project Name" labelStyle={{fontWeight:'bold',padding:'0px',margin:'0px'}} span={4}>{props.projectName}</Descriptions.Item>
                        <Descriptions.Item label="Salary Date" labelStyle={{fontWeight:'bold',padding:'0px',margin:'0px'}} span={4}>{props.salaryDate}</Descriptions.Item>
                        <Descriptions.Item label="Created Date">{today}</Descriptions.Item>
                    </Descriptions>
                </Col>
                <Col span={12}>
                    <img src={logo} className="plogo"/>
                </Col>
                <Col span={24} className="print">
                <Table
                    columns={columns}
                    dataSource={data}
                    className="table table-bordered"
                    
                    pagination={false}
                />
                </Col>
            </Row>
        </div>
    )
})

export default SalaryPrint;
